// extracted by mini-css-extract-plugin
export default {"rejectButtonBackground":"CommonButton_rejectButtonBackground__hUwEN","buttonText":"CommonButton_buttonText__77YBc"};